<template>
    <div>
        <Danjiags style="height:100px;" v-if="funtionName == 'danjia'" v-model="fun"></Danjiags>
        <price v-if="funtionName == 'price'" v-model="fun"></price>
        <HuoZhi style="height:100px;" v-if="funtionName == 'huoZhi'" v-model="fun"></HuoZhi>
        <paisong style="height:100px;" v-if="funtionName == 'paisong'" v-model="fun"></paisong>
        <shunFengChe style="height:200px;" v-if="funtionName == 'shunFengChe'" v-model="fun"></shunFengChe>
        <daZhuan style="height:200px;" v-if="funtionName == 'daZhuan'" v-model="fun"></daZhuan>
    </div>
</template>
<script>
import price from "./price.vue";
import Danjiags from "./danjia.vue";
import HuoZhi from "./huoZhi.vue";
import paisong from "./paisong.vue";
import shunFengChe from "./shunFengChe.vue";
import daZhuan from "./daZhuan.vue";
export default {
    props: ["bbb",],
    model: {
        prop: "bbb",
        event: "aaa",
    },
    components: { Danjiags, price, HuoZhi, paisong, daZhuan, shunFengChe },
    data() {
        return {
            funtionName: '',
            fun: ''
        }
    },
    methods: {
        tt() {
            this.funtionName = this.bbb.split("(")[0];
            this.fun = this.bbb;
        },


    },
    mounted() {
        this.tt();
    },
    watch: {
        fun(v) {
            this.$emit('aaa', v)
        },
        bbb(v) {

            this.tt();
        }
    },
}
</script>


// WEBPACK FOOTER //
// src/components/wuliu/kehu/gongshi/hanshu.vue